
<template>
  <div>
    <add-node type="text"></add-node>
    <add-node type="link"></add-node>
    <add-node type="div"></add-node>
    <add-node type="a"></add-node>
    <add-node type="span"></add-node>
    <add-node type="h1"></add-node>
    <draggable-tree :nodes="components"></draggable-tree>
  </div>
</template>

<script>
export default {
  name: 'ui-design-tree',
  props: {
    components: { type: Array }
  },
  methods: {
  },
  components: {
    AddNode: () => import('@/component/ui2/tree/AddNode'),
    DraggableTree: () => import('@/component/ui2/tree/DraggableTree')
  }
}
</script>
